import { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import "./style.css";

//storing the object of array in a const variable
const navigation = [
  { name: 'HOME', href: '/' },
  { name: 'BMI', href: '/BMI' },
  { name: 'EXCERISE', href: '/Exercise' },
  { name: 'NUTRIENT', href: '/Nutrient' },
  { name: 'RESOURCES', href: '/Resources' },
]

export default function Header() {
  const [responsive, setResponsive] = useState(false)

  return (
    <div className="bg-white ">
      <header className="absolute inset-x-0 top-0 z-50" id='header'>
        <nav className="flex items-center justify-between p-6 lg:px-8" aria-label="Global" id='nav'>
         {/* div that hold the logo inserted in nav  */}
          <div className="flex lg:flex-1">
            <Link to="/" className="-m-1.5 p-1.5" id='head'>
              <span className="sr-only">Your Company</span>
              <img
                className="h-8 w-auto"
                src="./assets/images/_Health-4-Life-1.png"
                alt="site Logo"
                id='logo'
              />
            </Link>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setResponsive(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          {/* mapping the object of array that contains the various navs and their link */}
          <div className="hidden lg:flex lg:gap-x-12">
            {navigation.map((item) => (
              <Link key={item.name} to = {item.href} className="text-sm font-semibold leading-6 text-gray-900">
                {item.name}

              </Link>
            ))}
          </div>
        </nav>
        <Dialog as="div" className="lg:hidden" open={responsive} onClose={setResponsive}>
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <Link to="/" className="-m-1.5 p-1.5">
                <span className="sr-only">Your Company</span>
                <img
                  className="h-8 w-auto"
                  src="./assets/images/_Health-4-Life-1.png"
                  alt="site Logo"
                />
              </Link>
              {/* button to that display the link in a responsive mode */}
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setResponsive(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
    </div>
  )
}
